import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CalloutContentModel } from '../user-access/models/callout-content.model';

@Component({
  selector: 'app-callout-content',
  templateUrl: './callout-content.component.html',
  styleUrls: ['./callout-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalloutContentComponent implements OnInit {
  @Input()
  content: CalloutContentModel;

  @Input()
  compact: boolean;

  @Output()
  actionClick = new EventEmitter();

  @Output()
  secondaryActionClick = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  handleActionClick() {
    this.actionClick.emit();
  }

  handleSecondaryActionClick() {
    this.secondaryActionClick.emit();
  }
}
